export default __webpack_public_path__ + "static/media/filled-tick-icon.64a05fbc.svg";